var version = {
    "name":      "dativery",
    "buildDateCode": "20260519-133717",
    "buildDate": "Tue May 19 2026 13:37:17 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260519-133717",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;